import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { isArray } from 'lodash';
import SampleImg from '../SampleImg';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import * as action from '../../../store/DevelopmentOrder.action';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';
import SampleImagedrope from '../../../../../Components/ImgDropzone/sampleImagedrope';
import './sampleImages.css';
import DragDropSort from '../../../../../Components/DragDropSort/DragDropSort';
import { removeImageOrientation } from '../../../../../Components/helper';
import { useComponent } from '../../../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';

function SampleImages({ show, toggle, handleUpdateImageData, isProductArchived, isSupplierLoggedIn }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [deleteImageId, setDeleteImageId] = useState({});
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const customStyles = {
    option: (provided) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '35px',
      borderBottom: '1px solid #848484',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
    menu: (provided) => ({
      ...provided,
      margin: '-1px 0 0 0',
      border: '1px solid #848484',
      borderRadius: 0,
      fontSize: 14,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
      fontFamily: 'Aktiv Grotesk, sans-serif !important',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
      fontSize: 14,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#aaa', // Custom colour
      padding: '8px 2px',
      svg: {
        width: '22px',
        height: '22px',
      },
    }),
  };
  const { Measuremets, Users } = devOrderReducer;

  const { sampleDetails, sampleAnnotationImage } = Measuremets;

  const { devOrderId } = useParams();
  const queryParams = useLocation();
  const { search } = queryParams;
  const smapleId = new URLSearchParams(search).get('sample');
  const childRef = useRef();
  const { logInRights } = Users;
  const { CheckActionPermission } = useComponent();
  const SampleEditAccess = CheckActionPermission(logInRights, 'products', 'samples', 'addEdit');

  const SampleDeleteAccess = CheckActionPermission(logInRights, 'products', 'samples', 'delete');
  const SampleAllAccess = CheckActionPermission(logInRights, 'products', 'samples', 'all');
  const [sampleImageData, setSampleImageData] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [sizeRange, setSizeRange] = useState([]);
  const [showDragDrop, setShowDragDrop] = useState(false);
  const [itemList, setitemList] = useState([]);
  const [replaceShow, setReplaceShow] = useState(false);
  const [replaceItem, setReplaceItem] = useState(null);
  const [parentIndex, setParentIndex] = useState(null);
  const [sampleImageId, setSampleImageId] = useState(null);
  const [state, setState] = useState({
    imageUploading: false,
  });
  const { imageUploading } = state;
  useEffect(() => {
    const colours = sampleDetails?.colourwayGroup?.map((item) => item.name) || [];
    const sizeComboList = sampleDetails?.gradingGroupData?.filter((ele) => ele?.size) || [];

    const buildLabel = (colour, size, length, quantity) => {
      const quan = quantity ? `(${quantity})` : ' ';
      const colourPrefix = colour ? `${colour}, ` : '';
      const lengthPart = length ? `, ${length} ${quan}` : ` ${quan}`;
      return `${colourPrefix}${size}${lengthPart}`;
    };

    const values =
      colours?.length > 0
        ? colours.flatMap((colour) =>
            sizeComboList.map((ele) => ({
              value: `${colour}-${ele?.size}-${ele?.len?.name || 'no-length'}`,
              label: buildLabel(colour, ele?.size, ele?.len?.name, ele?.quantity),
              size: ele?.size,
              colour,
              gradingId: ele?._id,
            })),
          )
        : sizeComboList.map((ele) => ({
            value: ele?._id,
            label: buildLabel(null, ele?.size, ele?.len?.name, ele?.quantity),
            size: ele?.size,
            gradingId: ele?._id,
          }));

    values?.length > 0 && values?.sort((a, b) => a.label.localeCompare(b.label));
    setSizeRange(values);
  }, [sampleDetails]);

  const replaceImageSubmit = async (data) => {
    let newData = data;

    if (isArray(data)) {
      // Check if the data contains S3 URLs that need special handling
      const hasS3Urls = data.some((item) => item?.image?.includes('amazonaws.com'));

      if (hasS3Urls) {
        // For S3 URLs, skip orientation removal to avoid CORS issues
        // The image is already processed and should be in the correct format
        newData = data;
      } else {
        // For regular files/blobs, apply orientation removal
        newData = await removeImageOrientation(data);
      }
    }

    // Ensure we have valid data
    if (!newData || !newData[0] || !newData[0].image) {
      console.error('Invalid image data:', newData);
      return;
    }

    const imageData = {
      image: newData[0].image,
      sampleId: smapleId,
      parentIndex,
      sampleImgId: sampleImageId,
      devOrderId,
    };
    setState((prev) => ({
      ...prev,
      imageUploading: true,
    }));
    await dispatch(action.replaceSampleImage(imageData, t));
    setState((prev) => ({
      ...prev,
      imageUploading: false,
    }));
    getSampleImage();
    if (data && replaceShow === true) {
      setReplaceShow(false);
    }
  };
  const handleImageUpload = async (data) => {
    if (data === 'close' && replaceShow === false) {
      toggle();
      return;
    }
    if (data === 'close' && replaceShow === true) {
      setReplaceShow(false);
      return;
    }
    if (replaceShow === true) {
      return replaceImageSubmit(data);
    }
    const params = {
      devOrderId,
      sampleId: smapleId,
    };

    if (data) {
      setState((prev) => ({
        ...prev,
        imageUploading: true,
      }));
      let newData = data;
      if (isArray(data)) {
        // Check if the data contains S3 URLs that need special handling
        const hasS3Urls = data.some((item) => item?.image?.includes('amazonaws.com'));

        if (hasS3Urls) {
          // For S3 URLs, skip orientation removal to avoid CORS issues
          // The image is already processed and should be in the correct format
          newData = data;
        } else {
          // For regular files/blobs, apply orientation removal
          newData = await removeImageOrientation(data);
        }
      }
      const imageData = {
        annotaeImage: newData,
        isSampleImages: true,
      };

      await dispatch(action.setSampleAnnotations(params, imageData, t));
      toggle();
      getSampleImage();
      setState((prev) => ({
        ...prev,
        imageUploading: false,
      }));
    }
  };

  const handleDeleteModal = () => {
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const getSampleImage = async (id) => {
    setIsLoader(true);
    const params = {
      devOrderId,
      sampleId: smapleId,
    };
    await dispatch(action.getSampleAnnotations(params));
    setIsLoader(false);
  };

  const deleteSampleImage = async () => {
    await dispatch(action.deleteSampleAnnotations(devOrderId, smapleId, deleteImageId, t));
    setShowConfirmationPopup(!showConfirmationPopup);
    getSampleImage();
  };

  useEffect(() => {
    getSampleImage();
  }, []);

  useEffect(() => {
    sampleAnnotationImage?.sampleAnnotateImages && setSampleImageData(sampleAnnotationImage?.sampleImages);
  }, [sampleAnnotationImage]);

  const replaceImage = (e, item, index) => {
    e.preventDefault();
    setParentIndex(index);
    setSampleImageId(item?._id);
    setReplaceItem(item);
    setReplaceShow(!replaceShow);
  };

  const reArrangeDocPosition = async (e, index) => {
    e.preventDefault();
    const itemslistData = sampleAnnotationImage?.sampleImages[index];
    itemslistData.map((ele) => {
      ele.parentIndex = index;
    });
    await setitemList(itemslistData);
    setShowDragDrop(!showDragDrop);
  };

  const hideShowDragDrop = () => {
    setShowDragDrop(!showDragDrop);
  };

  const handleSaveSequence = async (_e, sequenceList) => {
    const sampleId = sequenceList?.sequence[0].sampleId;
    const parentIndex = sequenceList?.sequence[0].parentIndex;
    const sampleImages = sequenceList?.sequence.map((e) => {
      delete e.sampleId;
      delete e.parentIndex;
      return e;
    });
    const params = {
      sampleId,
      parentIndex,
      sampleImages,
    };

    await action.saveSampleImagesSequence(params, t);
    getSampleImage();
    hideShowDragDrop();
  };

  const getImageUrl = (image) => {
    if (image?.includes('https:')) {
      return image;
    }
    return `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
  };

  const verticalList = (item, i, index) => {
    return (
      <div className="card-container" key={i}>
        <div className="image-header">
          <div className="flex-fill">
            <Select
              options={sizeRange}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              name="samples"
              value={item?.specification}
              onChange={(val) => {
                handleUpdateImageData(val, 'specification', i, index);
              }}
              placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.SELECT_SIZE')}
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              isDisabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />
          </div>
          {!isSupplierLoggedIn && (
            <>
              {SampleEditAccess && (
                <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.REARRANGE')}>
                  <button
                    type="button"
                    className="btn btn-outline d-none d-md-flex ml-16 mr-16"
                    aria-label="button"
                    onClick={(e) => reArrangeDocPosition(e, index)}
                    disabled={isProductArchived}
                  >
                    <i className="icon-Rearrange f-22" />
                  </button>
                </CustomTooltip>
              )}
              {(SampleAllAccess || SampleDeleteAccess) && (
                <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.REPLACE')}>
                  <button
                    type="button"
                    aria-label="button"
                    className="btn btn-outline ml-0 mr-16"
                    onClick={(e) => replaceImage(e, item, index)}
                    disabled={isProductArchived}
                  >
                    <i className="icon-Replace f-24" />
                  </button>
                </CustomTooltip>
              )}
              {(SampleAllAccess || SampleDeleteAccess) && (
                <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.DELETE')}>
                  <button
                    type="button"
                    aria-label="button"
                    disabled={isProductArchived}
                    onClick={() => {
                      setDeleteImageId({
                        designImageId: item?._id,
                        image: item?.image,
                        isSampleImages: true,
                        parentIndex: index,
                        title: item?.name || '',
                      });
                      setShowConfirmationPopup(true);
                    }}
                    className="btn btn-outline m-0"
                  >
                    <span className="icon-Delete f-24" />
                  </button>
                </CustomTooltip>
              )}
            </>
          )}
        </div>
        <div className="image-card">
          <div>
            <input
              name="Name"
              className="form-control text-bordered border-bottom"
              type="text"
              value={item?.name}
              maxLength="50"
              placeholder="Enter Name"
              onChange={(e) => {
                handleUpdateImageData(e.target.value, 'name', i, index);
              }}
              disabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />
          </div>
          <div className="d-md-none">
            <SampleImg src={getImageUrl(item?.image)} />
          </div>
          <div className="d-none d-md-block">
            <SampleImg src={getImageUrl(item?.image)} zoomClass="magnifier-zoom-container" />
          </div>
        </div>
      </div>
    );
  };

  const horizontalList = (item, i, index) => {
    return (
      <div className="card-container-hor" key={i}>
        <div className="image-header">
          <div className="flex-fill">
            <Select
              options={sizeRange}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              name="samples"
              value={item?.specification}
              isDisabled={isProductArchived}
              onChange={(val) => {
                handleUpdateImageData(val, 'specification', i, index);
              }}
              placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.SELECT_SIZES')}
            />
          </div>

          {!isSupplierLoggedIn && SampleEditAccess && (
            <>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.REARRANGE')}>
                <button
                  type="button"
                  className="btn btn-outline d-none d-md-flex ml-16 mr-16"
                  aria-label="button"
                  disabled={isProductArchived}
                  onClick={(e) => reArrangeDocPosition(e, index)}
                >
                  <i className="icon-Rearrange f-22" />
                </button>
              </CustomTooltip>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.REPLACE')}>
                <button
                  type="button"
                  className="btn btn-outline mr-16"
                  aria-label="button"
                  disabled={isProductArchived}
                  onClick={(e) => replaceImage(e, item, index)}
                >
                  <i className="icon-Replace f-24" />
                </button>
              </CustomTooltip>
            </>
          )}
          {!isSupplierLoggedIn && SampleDeleteAccess && (
            <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.DELETE')}>
              <button
                type="button"
                aria-label="button"
                disabled={isProductArchived}
                onClick={() => {
                  setDeleteImageId({
                    designImageId: item?._id,
                    image: item?.image,
                    isSampleImages: true,
                    parentIndex: index,
                    title: item?.name || '',
                  });
                  setShowConfirmationPopup(true);
                }}
                className="btn btn-outline m-0 "
              >
                <span className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
        </div>

        <div className="image-card-hor">
          <div className="flex-fill">
            <input
              name="Name"
              className="form-control text-bordered  border-bottom"
              type="text"
              placeholder="Enter Name"
              value={item?.name}
              disabled={isProductArchived}
              maxLength="50"
              onChange={(e) => {
                handleUpdateImageData(e.target.value, 'name', i, index);
              }}
            />
          </div>
          <div className="d-md-none">
            <SampleImg src={getImageUrl(item?.image)} />
          </div>
          <div className="d-none d-md-block">
            <SampleImg src={getImageUrl(item?.image)} zoomClass="magnifier-zoom-container-horizontal" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <div className="container-list">
          <div>
            {sampleImageData?.length > 0 ? (
              sampleImageData?.map((ele, index) => {
                return ele.length ? (
                  <div key={ele?._id} className="card-list_container">
                    {ele.map((item, i) => {
                      return item?.isVertical === true ? verticalList(item, i, index) : horizontalList(item, i, index);
                    })}
                  </div>
                ) : (
                  ''
                );
              })
            ) : (
              <Col md={12}>
                <div className=" my-4 py-4">
                  <p className="text-center">{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.NO_SAMPLE_IMAGE_FOUND')}</p>
                </div>
              </Col>
            )}
          </div>
        </div>
      )}
      {show && <ImgUpload show={show} toggle={toggle} childRef={childRef} handleImageUpload={handleImageUpload} imageUploading={imageUploading} />}

      {replaceShow && (
        <ImgUpload
          show={replaceShow}
          toggle={() => setReplaceShow(false)}
          childRef={childRef}
          handleImageUpload={handleImageUpload}
          replaceItem={replaceItem}
          fromRelace={replaceShow}
          imageUploading={imageUploading}
        />
      )}
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen
          onConfirm={deleteSampleImage}
          message={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.SAMPLE_IMAGE_MESSAGE')}
          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.DELETES')}
          toggle={handleDeleteModal}
        />
      )}
      {showDragDrop && (
        <DragDropSort
          devOrderId={devOrderId}
          itemList={itemList?.map((ele, i) => {
            ele._id = i;
            ele.sampleId = sampleAnnotationImage?.sampleId;
            return ele;
          })}
          isShow={showDragDrop}
          isToggle={hideShowDragDrop}
          saveSequence={handleSaveSequence}
          fromComp="sampleImagesItems"
        />
      )}
    </>
  );
}

function ImgUpload({ show, childRef, fromRelace, replaceItem, handleImageUpload, sampleImage, imageUploading, toggle }) {
  const { t } = useTranslation('common');
  return (
    <Modal className="common-custom-modal" size="xl" show={show} onHide={toggle} backdrop="static">
      <Modal.Header>
        <Modal.Title>{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SAMPLE_IMAGE.SAMPLE_IMAGES.UPLOAD_IMAGE')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {false ? (
          <Loader />
        ) : (
          <form>
            <SampleImagedrope
              ref={childRef}
              onSubmit={handleImageUpload}
              acceptedFileExtenstion=".jpeg,.jpg,.png"
              sampleImage={sampleImage}
              image=""
              isEditMode
              cropSize="4/4"
              replaceItem={replaceItem}
              fromRelace={fromRelace}
              loading={imageUploading}
            />
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SampleImages;
